import React from 'react';
import { isFF } from '../client-detection';
import { FEEDBACK_PREFIX, BLANK_URL } from '../constants/mailto';

export * from './use-element-sizes';
export * from './observe-element-sizes';
export { VisibilityObserver } from './visibility-observer';

export const absorb = (e: Event | React.SyntheticEvent) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
};

export const softAbsorb = (e: Event | React.SyntheticEvent) => {
    e?.stopPropagation?.();
};

/**
 * Generates className string from parts that are checked to be truthy.
 * @example concatClasses(isFlag && 'abc', 'bcd')
 * @example concatClasses([ isFlag && 'abc', 'bcd' ])
 */
export const concatClasses = (
    ...classes: Array<string | boolean | Array<string | boolean>>
): string =>
    (Array.isArray(classes[0]) && classes.length === 1 ? classes[0] : classes)
        .filter(Boolean)
        .join(' ');

export const openLinkInNewTab = (url: string): Window | null => {
    const newWindow = window.open(url, '_blank');
    if (isFF() && url.startsWith(FEEDBACK_PREFIX) && newWindow?.location.toString() === BLANK_URL) {
        newWindow.close();
    }
    return newWindow;
};

export const openLinkInSameTab = (url: string): void => {
    window.location.href = url;
};

export const getIsInputElementFocused = (): boolean => {
    const activeElement = document.activeElement;
    const isNativeInputElement =
        activeElement?.tagName && ['INPUT', 'TEXTAREA'].includes(activeElement?.tagName);
    return Boolean(isNativeInputElement || activeElement?.['isContentEditable']);
};
